import PropTypes from 'prop-types';

// eslint-disable-next-line import/prefer-default-export
export const compareListLabels = PropTypes.shape({
  berthText: PropTypes.string.isRequired,
  closeModalCtaText: PropTypes.string.isRequired,
  daysText: PropTypes.string.isRequired,
  durationLineItemText: PropTypes.string.isRequired,
  endDateLineItemText: PropTypes.string.isRequired,
  excursionLineItemText: PropTypes.string.isRequired,
  extraLineItemText: PropTypes.string.isRequired,
  flightClassLineItemText: PropTypes.string.isRequired,
  flightClassUpgradeAccordionText: PropTypes.string.isRequired,
  flightLineItemText: PropTypes.string.isRequired,
  flightUpgradeAccordionText: PropTypes.string.isRequired,
  fromPriceText: PropTypes.string.isRequired,
  genericErrorMessageText: PropTypes.string.isRequired,
  hotelLineItemText: PropTypes.string.isRequired,
  hotelUpgradeAccordionText: PropTypes.string.isRequired,
  locationLineItemText: PropTypes.string.isRequired,
  matchTournamentLineItemText: PropTypes.string.isRequired,
  maximumCompareAmountReachedValidationMessage: PropTypes.string.isRequired,
  merchandiseLineItemText: PropTypes.string.isRequired,
  modalComparingText: PropTypes.string.isRequired,
  modalRemoveAllCtaText: PropTypes.string.isRequired,
  modalTitleText: PropTypes.string.isRequired,
  motorhomeLineItemText: PropTypes.string.isRequired,
  motorhomeUpgradeAccordionText: PropTypes.string.isRequired,
  multiLanguageDetectedValidationMessage: PropTypes.string.isRequired,
  openModalCtaText: PropTypes.string.isRequired,
  perPersonText: PropTypes.string.isRequired,
  startDateLineItemText: PropTypes.string.isRequired,
  stopoverLineItemText: PropTypes.string.isRequired,
  ticketLineItemText: PropTypes.string.isRequired,
  ticketUpgradeAccordionText: PropTypes.string.isRequired,
  tourComponentAvailableText: PropTypes.string.isRequired,
  tourComponentNotAvailableText: PropTypes.string.isRequired,
  transportLineItemText: PropTypes.string.isRequired,
  transportUpgradeAccordionTitle: PropTypes.string.isRequired,
  viewTourCtaText: PropTypes.string.isRequired,
}).isRequired;
